import { RegimeCaisse } from '@/store/regimeCaisse/types';

export interface PS {
	numRPPS: string;
	typeIdentifiant: string;
	numAM: string;
	raisonSociale: string;
	mail: string;
	nom: string;
	prenom: string;
	categorie: string;
	specialite: string;
}

export interface InfosASSURE {
	codeCaisse: string;
	codeCentre: string;
	codeRegime: string;
	dateNaissance: string;
	nir: string;
	nomFamille: string;
	nomUsage: string;
	oppositionCarte: string;
	prenom: string;
	rangNaissance: number;
}

export interface InfosBENEF {
	dateNaissance: string;
	nir: string;
	nomFamille: string;
	nomUsage: string;
	prenom: string;
	rangNaissance: number;
}

export class InfosPSBEN {
	ps: PS;
	infosASSURE: InfosASSURE;
	infosBENEF: InfosBENEF;

	constructor(data: { infosPS: PS, infosASSURE: InfosASSURE, infosBENEF: InfosBENEF }) {
		this.ps = data.infosPS;
		this.infosASSURE = data.infosASSURE;
		this.infosBENEF = data.infosBENEF;
	}
}

export interface InfosPSBENState {
	infosPSBEN?: InfosPSBEN;
	error: boolean;
	loaded: boolean;
}
